import { render, staticRenderFns } from "./PensionCalculatorTab.vue?vue&type=template&id=5cb4ab34&scoped=true"
import script from "./PensionCalculatorTab.vue?vue&type=script&lang=js"
export * from "./PensionCalculatorTab.vue?vue&type=script&lang=js"
import style0 from "./PensionCalculatorTab.vue?vue&type=style&index=0&id=5cb4ab34&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cb4ab34",
  null
  
)

export default component.exports